import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        iconWrapper: {
            height: theme.typography.h2.lineHeight,
            padding: theme.spacing(0, 0.5, 0, 0),
            display: 'flex',
            alignItems: 'center',
        },
        cloudDoneIcon: {
            '&&': {
                color: theme.palette.primary[200],
                width: theme.spacing(2),
                height: theme.spacing(2),
            },
        },
        cloudOffIcon: {
            '&&': {
                color: theme.palette.common.black,
                width: theme.spacing(2),
                height: theme.spacing(2),
            },
        },
    }
})

export default useStyles
